import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { trackHeaderCTA } from '../tracking';
import { scrollToLeadForm } from '../utils/scroll';
import type { Language } from '../types/lead';
export function Header() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleCTA = () => {
    trackHeaderCTA();
    scrollToLeadForm();
  };
  const languages: Language[] = ['en', 'es'];
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-camel/30 bg-white/95 shadow-sm backdrop-blur-md' : 'border-b border-transparent bg-white/80 backdrop-blur-sm'}`} data-id="element-77" data-mp="36a0enknwpowu">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6" data-id="element-78" data-mp="2wlduliys4t74">
        <a href="#top" className="font-display text-[13px] font-extrabold uppercase leading-none tracking-[0.18em] text-ink sm:text-base" data-id="element-79" data-mp="2rli2oi3cws7x">
          MIAMI CAR QUEENS
        </a>

        <div className="flex items-center gap-2 sm:gap-4" data-id="element-80" data-mp="2hodaa0ix40io">
          <div role="group" aria-label={t('nav.language')} className="flex items-center overflow-hidden border border-ink/25" data-id="element-81" data-mp="3fbcecwbxwaql">
            {languages.map(code => <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={lang === code} className={`min-h-[40px] px-2.5 text-xs font-bold uppercase tracking-[0.14em] transition-colors sm:min-h-[44px] sm:px-3 ${lang === code ? 'bg-ink text-white' : 'text-ink/60 hover:text-ink'}`} data-id="element-82" data-mp="35l9cs7qr5ogn">
                {code}
              </button>)}
          </div>

          {/* Only ONE gold-filled CTA per viewport: while the hero (and its gold CTA)
              is on screen this stays an outline, and fills with gold after scrolling. */}
          <button type="button" onClick={handleCTA} className={`min-h-[44px] px-3 text-[11px] font-bold uppercase tracking-[0.12em] transition-all sm:min-h-[48px] sm:px-5 sm:text-xs ${scrolled ? 'bg-gold text-golddeep hover:-translate-y-[1px]' : 'border border-ink text-ink hover:bg-ink hover:text-white'}`} data-id="element-83" data-mp="1mmuyd3un7f4t">
            {t('nav.cta')}
          </button>
        </div>
      </div>
    </header>;
}